// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ProbingQuestions = function (x) {
    return x;
};
var tsBridgeProbingQuestions = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ProbingQuestions")("__brandProbingQuestions"));
    }
};
var writeProbingQuestions = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showProbingQuestions = Data_Show.showString;
var readProbingQuestions = Simple_JSON.readString;
var ordProbingQuestions = Data_Ord.ordString;
var newtypeProbingQuestions = {
    Coercible0: function () {
        return undefined;
    }
};
var makeProbingQuestions = ProbingQuestions;
var eqProbingQuestions = Data_Eq.eqString;
export {
    ProbingQuestions,
    makeProbingQuestions,
    unwrap,
    newtypeProbingQuestions,
    eqProbingQuestions,
    ordProbingQuestions,
    showProbingQuestions,
    readProbingQuestions,
    writeProbingQuestions,
    tsBridgeProbingQuestions
};
//# sourceMappingURL=index.js.map
